import { Spacer, Text } from "@hackthenorth/north";
import { TrashIcon } from "@heroicons/react/24/outline";
import React from "react";
import styled from "styled-components";

import { Modal } from "src/shared/components";

import FooterActions from "../../../../footerActions";
import { MODAL_FIELDS } from "../constants";

export interface DeleteModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  type: "QUEST" | "PRIZE";
}
const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  type,
}) => {
  const field = MODAL_FIELDS[type].delete;
  return (
    <Modal isOpen={isOpen}>
      <HeaderContainer>
        <HeaderIcon>
          <TrashIcon color="red" />
        </HeaderIcon>
        <Text mods="h3 bold textDanger">{field.title}</Text>
      </HeaderContainer>
      <DescriptionWrapper>
        <Text mods="body">{field.message}</Text>
        <Text mods="bold">You can&apos;t undo this action.</Text>
      </DescriptionWrapper>
      <Spacer height={36} />
      <FooterActions
        confirmText={"Confirm"}
        onConfirm={onConfirm}
        onCancel={onCancel}
        isDelete
      />
    </Modal>
  );
};

export default DeleteModal;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  gap: 8px;
`;

const HeaderIcon = styled.div<{ backgroundColor?: string }>`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;
`;

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
